import { Link, usePage } from "@inertiajs/react"
import {
  AtSign,
  Key,
  ListTodo,
  Mail,
  Newspaper,
  Plug,
  Settings,
  Shield,
  Ticket,
} from "lucide-react"

import { NavMain } from "@/components/nav-main"
import { NavUser } from "@/components/nav-user"
import { TeamSwitcher } from "@/components/team-switcher"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import {
  avoPath,
  connectedAccountsPath,
  editTeamPath,
  mentionHandleGroupsPath,
  referralCodesPath,
  solidQueueMonitorRootPath,
  storiesPath,
  teamApiKeysPath,
} from "@/routes"
import type { NavItem, SharedProps } from "@/types"

import AppLogo from "./app-logo"

export function AppSidebar() {
  const { auth, rails_env } = usePage<SharedProps>().props

  const mainNavItems: NavItem[] = [
    {
      title: "Newsroom",
      href: storiesPath(),
      icon: Newspaper,
    },
    {
      title: "Connected Accounts",
      href: connectedAccountsPath(),
      icon: Plug,
    },
    {
      title: "Mentions",
      href: mentionHandleGroupsPath(),
      icon: AtSign,
    },
    {
      title: "Referrals",
      href: referralCodesPath(),
      icon: Ticket,
    },
    {
      title: "API Keys",
      href: teamApiKeysPath(),
      icon: Key,
    },
    {
      title: "Team Settings",
      href: editTeamPath(),
      icon: Settings,
    },
  ]

  return (
    <Sidebar collapsible="icon" variant="inset">
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg" asChild>
              <Link href={storiesPath()} prefetch>
                <AppLogo />
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
        <TeamSwitcher />
      </SidebarHeader>

      <SidebarContent>
        <NavMain items={mainNavItems} />
        {auth.user.super_admin && (
          <SidebarGroup className="px-2 py-0">
            <SidebarGroupLabel>Admin</SidebarGroupLabel>
            <SidebarMenu>
              <SidebarMenuItem>
                <SidebarMenuButton asChild tooltip={{ children: "Admin" }}>
                  <a href={avoPath()}>
                    <Shield />
                    <span>Admin</span>
                  </a>
                </SidebarMenuButton>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuButton asChild tooltip={{ children: "Jobs" }}>
                  <a href={solidQueueMonitorRootPath()}>
                    <ListTodo />
                    <span>Jobs</span>
                  </a>
                </SidebarMenuButton>
              </SidebarMenuItem>
              {rails_env === "development" && (
                <SidebarMenuItem>
                  <SidebarMenuButton
                    asChild
                    tooltip={{ children: "Mail Previews" }}
                  >
                    <a href="/rails/mailers">
                      <Mail />
                      <span>Mail Previews</span>
                    </a>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              )}
            </SidebarMenu>
          </SidebarGroup>
        )}
      </SidebarContent>

      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
    </Sidebar>
  )
}
